import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private permissions = new Set<string>();
  private PERMISSIONS_KEY = 'app_permissions';

  constructor() {
    const stored = localStorage.getItem(this.PERMISSIONS_KEY);
    if (stored) {
      try {
        const parsed: string[] = JSON.parse(stored);
        this.permissions = new Set(parsed);
      } catch (e) {
        console.error('Invalid permissions in localStorage', e);
        this.permissions.clear();
      }
    }
  }

  setPermissions(permissions: string[]) {
    this.permissions = new Set(permissions);
    localStorage.setItem(this.PERMISSIONS_KEY, JSON.stringify(permissions));
  }

  has(permission: string): boolean {
    return this.permissions.has(permission);
  }

  hasAny(...perms: string[]): boolean {
    return perms.some(p => this.permissions.has(p));
  }

  clearPermissions() {
    this.permissions.clear();
    localStorage.removeItem(this.PERMISSIONS_KEY);
  }
}